import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const negations = ['No es un curso.', 'No es teoría.', 'No es otra lista de «deberías».'];
const affirmations = ['Es un bálsamo para tu alma.', 'Es un ritual.', 'Es una vuelta a ti.'];
export function Solution() {
  return <section className="w-full bg-cream py-20 sm:py-28" aria-labelledby="solution-title" data-id="element-170" data-mp="15r8wotrxbe1b">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-171" data-mp="quqgsv8vo5vv">
        <SectionHeading eyebrow="Por eso creamos esto" title={<>
              Método <em className="not-italic text-clay" data-id="element-173" data-mp="hulakoff7dja">Me Elijo</em>
            </>} intro={<>
              Un viaje de transformación para volver a ti, fortalecer tu autoestima y
              construir la vida que mereces. ¿Y si hoy dejaras de postergarte, de dudar
              de ti y de poner las necesidades de todos por encima de las tuyas?
            </>} data-id="element-172" data-mp="vu34tjbhjj01" />

        <div className="mt-14 grid gap-4 sm:grid-cols-2" data-id="element-174" data-mp="708kk4uxl5w3">
          <motion.ul initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.6
        }} className="space-y-3 rounded-3xl border border-plum/10 bg-white/50 p-8" data-id="element-175" data-mp="6ynr6ikcrszt">
            {negations.map(item => <li key={item} className="font-display text-2xl text-ink/45 line-through decoration-clay/40" data-id="element-176" data-mp="3k6ihmcodqj3q">
                {item}
              </li>)}
          </motion.ul>

          <motion.ul initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="space-y-3 rounded-3xl bg-sand p-8" data-id="element-177" data-mp="3u56k233vspmb">
            {affirmations.map(item => <li key={item} className="font-display text-2xl text-plum" data-id="element-178" data-mp="14fcpi2a3gd4g">
                {item}
              </li>)}
          </motion.ul>
        </div>

        <div className="mt-14 grid gap-10 rounded-[2rem] bg-plum/[0.04] p-8 sm:p-12 lg:grid-cols-2 lg:items-center" data-id="element-179" data-mp="1gi5q7evxuzsh">
          <div data-id="element-180" data-mp="1lh8q6kx2aftl">
            <h3 className="font-display text-3xl leading-tight text-plum sm:text-4xl" data-id="element-181" data-mp="1litngiargcv5">
              Mucho más que un e-book
            </h3>
            <p className="mt-5 text-base leading-relaxed text-ink/75 sm:text-lg" data-id="element-182" data-mp="1qe8x0y1qjmlr">
              Es una guía práctica de crecimiento personal diseñada para ayudarte a
              reconectar contigo misma, fortalecer tu confianza, establecer límites
              saludables y desarrollar hábitos que te acerquen a la vida que deseas.
            </p>
            <p className="mt-4 text-base leading-relaxed text-ink/75 sm:text-lg" data-id="element-183" data-mp="17iiwlf9gay9z">
              A través de reflexiones, ejercicios y herramientas de autoconocimiento,
              aprenderás a identificar las creencias que te limitan, transformar tu
              diálogo interno y empezar a actuar desde el amor propio, la seguridad y la
              intención.
            </p>
          </div>
          <img src="https://cdn.shopify.com/s/files/1/0825/1706/5986/files/ESPALDA...png?v=1786136743" alt="Mujer leyendo con calma junto a la ventana con una taza de té" className="h-full w-full rounded-3xl object-cover shadow-soft" loading="lazy" data-id="element-184" data-mp="2jvodpxm911l" />
        </div>
      </div>
    </section>;
}